import 'normalize.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store, persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import YandexMetrica from './components/metrics/YandexMetrica';
import PreloadAssets from './components/seo/PreloadAssets';

if (process.env.NODE_ENV === 'production') {
    (window as any).dataLayer = (window as any).dataLayer || [];
}

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <HelmetProvider>
            <React.StrictMode>
                <Provider store={store}>
                    <PersistGate loading={<div>Загрузка...</div>} persistor={persistor}>
                        <>
                            <PreloadAssets />
                            <YandexMetrica />
                            <App />
                            <Toaster
                                position="bottom-left"
                                toastOptions={{
                                    style: { fontSize: '14px', lineHeight: '1.2' },
                                    duration: 6000,
                                }}
                            />
                        </>
                    </PersistGate>
                </Provider>
            </React.StrictMode>
        </HelmetProvider>
    </BrowserRouter>,
);
